import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import DomainContent from './DomainContent';

export default function CasinoDomains() {
  return (
    <CasinoContainer title={'Domains and aliases'}>
      <DomainContent />
    </CasinoContainer>
  );
}
